import { PayloadAction } from "@reduxjs/toolkit";
import { ClientsState } from "../../models/ClientsState";
import { DeleteClientForVendorPayload } from "../../payload/DeleteClientForVendor/DeleteClientForVendorPayload";

const deleteForVendorFetch = (state: ClientsState, action: PayloadAction<DeleteClientForVendorPayload>) => {
    state.isLoading = true;
}

export default deleteForVendorFetch;